import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { modalFormStyles } from "../../../../assets/styles/tableContainer";
import LanguageHelper from "../../../../helpers/LanguageHelper";
import {
  FormControl,
  CircularProgress,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

const useStyles = makeStyles((theme) => modalFormStyles(theme));

const types = ["BACKEND", "FRONTEND"];

export default function ModalForm({
  applicationUpdateProps,
  setApplicationUpdateProps,
  createApplicationUpdate,
  loading,
  options,
}) {
  const classes = useStyles();
  const language = LanguageHelper.getLanguage();
  const [errors, setErrors] = React.useState({});
  const [openConfirmDialog, setOpenConfirmDialog] = React.useState(false);
  const [latestArtifact, setLatestArtifact] = React.useState("");

  const getLatestArtifact = (type) => {
    if (type === "BACKEND") {
      setLatestArtifact(options.latestBackendUpdate.latest);
      setApplicationUpdateProps({
        ...applicationUpdateProps,
        type: "BACKEND",
        description: options.latestBackendUpdate.description,
      });
    } else if (type === "FRONTEND") {
      setLatestArtifact(options.latestFrontendUpdate.latest);
      setApplicationUpdateProps({
        ...applicationUpdateProps,
        type: "FRONTEND",
        description: options.latestFrontendUpdate.description,
      });
    } else {
      setLatestArtifact("No artifact found");
      setApplicationUpdateProps({
        ...applicationUpdateProps,
        type: "",
        description: "",
      });
    }
  };

  const onButtonClick = () => {
    let error = false;
    let errorMessage = "Bu alan boş bırakılamaz.";
    let errors = {
      type: null,
      username: null,
      password: null,
      description: null,
    };

    if (!applicationUpdateProps.type) {
      errors.type = errorMessage;
      error = true;
    }
    if (!applicationUpdateProps.description) {
      errors.description = errorMessage;
      error = true;
    }
    setErrors(errors);

    if (!error) {
      createApplicationUpdate();
    }
  };

  const handleCheckboxChange = (event) => {
    if (event.target.checked) {
      // If user is checking the box, show confirmation
      setOpenConfirmDialog(true);
    } else {
      // If user is unchecking, no confirmation needed
      setApplicationUpdateProps({
        ...applicationUpdateProps,
        dbBackup: false,
      });
    }
  };

  return (
    <FormControl noValidate autoComplete="off" className={classes.formControl}>
      <Autocomplete
        options={types}
        getOptionLabel={(option) => option}
        fullWidth
        value={applicationUpdateProps?.type}
        onChange={(event, value) => {
          getLatestArtifact(value);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label={language.applicationUpdates.type}
            required
            error={errors?.type}
            helperText={errors?.type}
            className={classes.textField}
          />
        )}
      />

      <TextField
        label={language.applicationUpdates.latestArtifact}
        fullWidth
        value={latestArtifact}
        disabled
        variant="outlined"
        className={classes.textField}
      />

      <TextField
        label={language.applicationUpdates.description}
        required
        fullWidth
        multiline
        minRows={4}
        maxRows={8}
        variant="outlined"
        value={applicationUpdateProps?.description || " "}
        onChange={(event) =>
          setApplicationUpdateProps({
            ...applicationUpdateProps,
            description: event.target.value,
          })
        }
        error={errors?.description}
        helperText={errors?.description}
        className={classes.textField}
      />

      {applicationUpdateProps?.type === "BACKEND" && (
        <FormControlLabel
          control={
            <Checkbox
              checked={applicationUpdateProps?.dbBackup}
              onChange={handleCheckboxChange}
              color="primary"
            />
          }
          label={language.applicationUpdates.dbBackup}
          className={classes.textField}
        />
      )}

      <Dialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Veritabanı yedeklemesi yapmak istediğinizden emin misiniz?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmDialog(false)} color="primary">
            {language.etc.no}
          </Button>
          <Button
            onClick={() => {
              setApplicationUpdateProps({
                ...applicationUpdateProps,
                dbBackup: true,
              });
              setOpenConfirmDialog(false);
            }}
            color="secondary"
            autoFocus
          >
            {language.etc.yes}
          </Button>
        </DialogActions>
      </Dialog>

      <div style={{ paddingBottom: 20, textAlign: "center" }}>
        {loading ? (
          <CircularProgress color="secondary" />
        ) : (
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            onClick={onButtonClick}
            className={classes.submit}
          >
            {language.modal.publish}
          </Button>
        )}
      </div>
    </FormControl>
  );
}
